import Logo from '@/components/Logo'
import Link from 'next/link'

const DESKTOP_COLS = [
	{
		t: 'विभाग',
		items: [
			{ label: 'सर्व बातम्या', href: '/all-news' },
			{ label: 'ताज्या बातम्या', href: '/latest-news' },
			{ label: 'ट्रेंडिंग', href: '/trending' },
			{ label: 'शहरानुसार', href: '/city-wise-news' },
			{ label: 'सर्वाधिक वाचलेले', href: '/most-read' },
		],
	},
	{
		t: 'कंपनी',
		items: [
			{ label: 'आमच्याबद्दल', href: '/company/about-us' },
			{ label: 'संपर्क', href: '/company/contact-us' },
			{ label: 'संपादकीय धोरण', href: '/company/editorial-policy' },
			{ label: 'जाहिरात द्या', href: '/company/advertise' },
		],
	},
	{
		t: 'धोरणे',
		items: [
			{ label: 'गोपनीयता', href: '/company/privacy-policy' },
			{ label: 'अटी व शर्ती', href: '/company/terms-and-conditions' },
			{ label: 'कुकी धोरण', href: '/company/cookie-policy' },
		],
	},
	{
		t: 'बातम्या',
		items: [
			{ label: 'निवडक बातम्या', href: '/recommended' },
			{ label: 'अलीकडे अद्यतन', href: '/recently-updated' },
			{ label: 'एव्हरग्रीन', href: '/evergreen' },
			{ label: 'मिनी ट्रेंडिंग', href: '/mini-trending' },
		],
	},
]

const SOCIAL_LINKS = [
	{ label: 'Facebook', href: 'https://www.facebook.com/prajavarta/' },
	{ label: 'Instagram', href: 'https://www.instagram.com/prajavarta/' },
	{ label: 'X (Twitter)', href: 'https://x.com/prajavarta?s=20' },
]

export default function Footer() {
	return (
		<footer className="bg-[#0f1f2e] text-white mt-8 md:mt-10">
			<div className="site-container py-6 md:py-10">
				<div className="grid grid-cols-2 lg:grid-cols-[1.5fr_repeat(4,minmax(0,1fr))] gap-6 lg:gap-10 mb-6 md:mb-8">
					<div className="col-span-2 lg:col-span-1">
						<Logo big inverted />
						<p className="mr text-[13px] leading-relaxed opacity-70 mt-3 max-w-xs">
							मराठीतून विश्वासार्ह बातम्या · संपादकीय निष्ठा आणि वाचनीय अनुभव.
						</p>
						<div className="mt-4">
							<h2 className="mr text-xs font-bold mb-2 opacity-85">आम्हाला फॉलो करा</h2>
							<ul className="flex flex-wrap gap-x-4 gap-y-2">
								{SOCIAL_LINKS.map((item) => (
									<li key={item.label}>
										<a
											href={item.href}
											target="_blank"
											rel="noopener noreferrer"
											className="text-xs md:text-[13px] opacity-70 hover:opacity-100 transition-opacity"
										>
											{item.label}
										</a>
									</li>
								))}
							</ul>
						</div>
					</div>

					{DESKTOP_COLS.map((col) => (
						<div key={col.t}>
							<div className="mr text-[11px] md:text-xs font-bold tracking-widest uppercase mb-2.5 md:mb-3 opacity-85">
								{col.t}
							</div>
							<ul className="flex flex-col gap-2 md:gap-2.5">
								{col.items.map((item) => (
									<li key={item.href}>
										<Link
											href={item.href}
											className="mr text-xs md:text-[13px] opacity-70 hover:opacity-100 transition-opacity"
										>
											{item.label}
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				<div className="border-t border-white/10 pt-4 md:pt-5 flex flex-col sm:flex-row justify-between items-start sm:items-center text-[10px] md:text-xs opacity-60 gap-2 sm:gap-4">
					<span>© 2026 Prajavarta Media Pvt. Ltd. RNI: MAHMAR/2024/12345</span>
					{/* <span>v1.0</span> */ /* this is a comment */} 
				</div>
			</div>
		</footer>
	)
}
